import { httpPost } from '@/utils/income-request'
import type { ResponseBase } from '@/utils/income-request'

export const DICT_TYPES_MAP = {
  POSITION_TYPE: 'POSITION_TYPE', //职务
  SEX_TYPE: 'SEX_TYPE', // 性别
  MARRIAGE_STATUS: 'MARRIAGE_STATUS', // 婚姻状况
  EDUCATION_TYPE: 'EDUCATION_TYPE', // 学历
  DEGREE_TYPE: 'DEGREE_TYPE', // 学位
  WORK_TYPE: 'WORK_TYPE', // 职业类型
  LIVE_TYPE: 'LIVE_TYPE', // 居住状况
  RELATION_TYPE: 'RELATION_TYPE', // 关系
  COMPANY_TYPE: 'COMPANY_TYPE', // 单位性质
  MONTHLY_INCOME_TYPE: 'MONTHLY_INCOME_TYPE', // 月收入
  INDUSTRY_TYPE: 'INDUSTRY_TYPE', // 行业
  CREDIT_TYPE: 'CREDIT_TYPE', // 信贷类型
  CREDIT_STATUS: 'CREDIT_STATUS', // 信贷状态
  BIND_CARD_STATUS: 'BIND_CARD_STATUS', // 绑卡状态
  INTEREST_TYPE: 'INTEREST_TYPE', // 计息方式
  LOAN_STATUS: 'LOAN_STATUS', // 借款状态
  REPAY_STATUS: 'REPAY_STATUS', // 还款状态
  LOAN_USAGE: 'LOAN_USAGE', // 借款用途
  REPAY_TYPE: 'REPAY_TYPE', // 还款类型
  REPAY_DETAIL_STATUS: 'REPAY_DETAIL_STATUS', // 还款明细状态
  REPAY_WAY_TYPE: 'REPAY_WAY_TYPE', // 还款方式
  TEMPLATE_TYPE: 'TEMPLATE_TYPE', // 模板类型
  SOCIAL_DURATION: 'SOCIAL_DURATION', // 社保时长
  FUND_DURATION: 'FUND_DURATION', // 公积金时长
  CAR_STATE: 'CAR_STATE', // 车产状态
  INSURE_STATE: 'INSURE_STATE', // 保单状态
  HOUSE_STATE: 'HOUSE_STATE', // 房产状态
  CREDIT_CARD_STATE: 'CREDIT_CARD_STATE', // 信用卡状态
  LINKMAN_SCENE: 'LINKMAN_SCENE', // 场景
  TOPIC_SCORE: 'TOPIC_SCORE', // 主题
  LOAN_SCORE: 'LOAN_SCORE', // 分数
  DECISION_STATE: 'DECISION_STATE', // 决策状态
  PERIOD_TYPE: 'PERIOD_TYPE', // 期数类型
}

// 所有字典类型
export const DICT_TYPES = [
  DICT_TYPES_MAP.POSITION_TYPE, //职务
  DICT_TYPES_MAP.SEX_TYPE, // 性别
  DICT_TYPES_MAP.MARRIAGE_STATUS, // 婚姻状况
  DICT_TYPES_MAP.EDUCATION_TYPE, // 学历
  DICT_TYPES_MAP.DEGREE_TYPE, // 学位
  DICT_TYPES_MAP.WORK_TYPE, // 职业类型
  DICT_TYPES_MAP.LIVE_TYPE, // 居住状况
  DICT_TYPES_MAP.RELATION_TYPE, // 关系
  DICT_TYPES_MAP.COMPANY_TYPE, // 单位性质
  DICT_TYPES_MAP.MONTHLY_INCOME_TYPE, // 月收入
  DICT_TYPES_MAP.INDUSTRY_TYPE, // 行业
  DICT_TYPES_MAP.CREDIT_TYPE, // 信贷类型
  DICT_TYPES_MAP.CREDIT_STATUS, // 信贷状态
  DICT_TYPES_MAP.BIND_CARD_STATUS, // 绑卡状态
  DICT_TYPES_MAP.INTEREST_TYPE, // 计息方式
  DICT_TYPES_MAP.LOAN_STATUS, // 借款状态
  DICT_TYPES_MAP.REPAY_STATUS, // 还款状态
  DICT_TYPES_MAP.LOAN_USAGE, // 借款用途
  DICT_TYPES_MAP.REPAY_TYPE, // 还款类型
  DICT_TYPES_MAP.REPAY_DETAIL_STATUS, // 还款明细状态
  DICT_TYPES_MAP.REPAY_WAY_TYPE, // 还款方式
  DICT_TYPES_MAP.TEMPLATE_TYPE, // 模板类型
  DICT_TYPES_MAP.SOCIAL_DURATION, // 社保时长
  DICT_TYPES_MAP.FUND_DURATION, // 公积金时长
  DICT_TYPES_MAP.CAR_STATE, // 车产状态
  DICT_TYPES_MAP.INSURE_STATE, // 保单状态
  DICT_TYPES_MAP.HOUSE_STATE, // 房产状态
  DICT_TYPES_MAP.CREDIT_CARD_STATE, // 信用卡状态
  DICT_TYPES_MAP.LINKMAN_SCENE, // 场景
  DICT_TYPES_MAP.TOPIC_SCORE, // 主题
  DICT_TYPES_MAP.LOAN_SCORE, // 分数
  DICT_TYPES_MAP.DECISION_STATE, // 决策状态
  DICT_TYPES_MAP.PERIOD_TYPE, // 期数类型
] as const

export type DictType = (typeof DICT_TYPES)[number]

export interface DictValue {
  dictCode: number
  dictLabel: string
  dictValue: string
}

export interface DictData {
  dictId: number
  dictName: string
  dictType: DictType
  dictValues: DictValue[]
}

export function getDictList() {
  return httpPost<ResponseBase<DictData[]>>('/dict/data/batchList', {
    dictTypes: DICT_TYPES,
  })
}
